module.exports = __webpack_public_path__ + "static/media/tikkho-maciel-2-_WkjmC8x4-unsplash.e5947f5c.jpg";